import { atom } from 'jotai'

/**
 * 配車板の配送日（shippingDate）をグローバル管理
 */
export const shippingDateAtom = atom<string | undefined>(undefined)
shippingDateAtom.debugLabel = 'shippingDateAtom'
